import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { TeamsService } from '@teams/infra';
import { MemberRole, TeamDto } from '@core-http';
import { MyTeamsDto } from '@orlikfy/api-interfaces';
import { GetHostTeamsQueryResult } from './get-host-teams.query-result';

export class GetHostTeamsQueryHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  getHostTeams(): Observable<GetHostTeamsQueryResult[]> {
    return this.teamsService.getTeams().pipe(
      map((dto: MyTeamsDto) => dto.teams),
      map((teams: TeamDto[]) => teams?.filter((team: TeamDto) => team.memberRole === MemberRole.Host)),
      map((teams: TeamDto[]) =>
        teams?.map(
          (team: TeamDto): GetHostTeamsQueryResult => ({
            teamId: team.teamId,
            teamName: team.teamName,
            membersCount: team.members.length
          })
        )
      )
    );
  }
}
